@if (isNewNavigationOn) {
  <div class="shell-wrapper">
    @if (!fromAccounts) {
      <div class="shell-wrapper__action-bar"><shell-action-bar /></div>
    }
    <div class="shell-wrapper__container">
      @if (!fromAccounts) {
        <shell-menu [menuItems]="menuItems" [lastUrl]="lastUrl()" />
      }
      <div class="bg-white content h-full w-full shell-borders">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <ng-container *ngIf="isScreenSmall">
    <treo-vertical-navigation
      class="bg-cool-gray-900 theme-dark"
      [appearance]="'classic'"
      [mode]="'over'"
      [name]="'verticalMainNavigation'"
      [navigation]="menuItems"
      [opened]="false"
    >
      <div treoVerticalNavigationContentHeader>
        <div class="logo">
          <img src="assets/images/logo/ts-intapp-logo.png" />
        </div>
      </div>
    </treo-vertical-navigation>
  </ng-container>
  <div class="wrapper">
    <div #header class="header">
      <div class="logo" *ngIf="!isScreenSmall">
        <img class="logo-text" src="assets/images/logo/ts-intapp-logo.png" />
        <img class="logo-text-on-dark" src="assets/images/logo/logo-text-on-dark.svg" />
        <img class="logo-base" src="assets/images/logo/ts-intapp-logo.png" />
      </div>
      <ng-container *ngIf="!fromAccounts && account.id">
        <div class="main-navigation" #mainNavigation *ngIf="!isScreenSmall">
          <treo-horizontal-navigation
            name="mainNavigation"
            [navigation]="menuItems"
            id="mainNavigation"
          ></treo-horizontal-navigation>
        </div>

        <ts-button
          class="navigation-toggle-button"
          *ngIf="isScreenSmall"
          name="mainNavigation"
          id="mainNavigation"
          [attr.data-testid]="'main-navigation-toggle-vertical-menu-button'"
          type="icon"
          color="basic"
          icon="menu"
          (buttonClick)="toggleNavigation('verticalMainNavigation')"
        ></ts-button>

        <ng-container *ngIf="!isTaskCollaborator">
          <div class="menu-actions">
            <div class="spacer"></div>
            <search [appearance]="'bar'" [account]="account"></search>
            <notifications />
            <calculator></calculator>
            <div *ngIf="canAccessEthan" class="mr-2 ml-2 w-6 h-6 cursor-pointer">
              <img
                src="assets/icons/ethan-avatar.svg"
                class=""
                [ngClass]="{
                  'opacity-50': !isFloatingEthanVisible,
                  'cursor-pointer transition-opacity duration-200': true,
                }"
                (click)="toggleFloatingEthan()"
                [title]="isFloatingEthanVisible ? 'Disable Ethan Bot' : 'Enable Ethan Bot'"
                alt="Ethan Avatar"
              />
            </div>
            @if (account?.celeste_url) {
              <a
                [href]="account.celeste_url"
                target="_blank"
                rel="noopener noreferrer"
                class="celeste-link mr-2 ml-2 flex items-center justify-center cursor-pointer pt-1 h-10 w-10"
                title="Open Celeste"
              >
                <img
                  class="select-none pointer-events-none w-full h-full object-contain"
                  src="assets/icons/celeste.svg"
                  alt="Celeste"
                />
              </a>
            }
            <span class="rnw-badge">
              <mat-icon class="cursor-pointer" [fontIcon]="'campaign'"></mat-icon>
            </span>
            <support-hub></support-hub>
          </div>
        </ng-container>
        <user *ngIf="data?.user" [user]="data.user" [isTaskCollaborator]="isTaskCollaborator"></user>
      </ng-container>
    </div>
    <div class="bg-white content">
      <router-outlet *ngIf="true"></router-outlet>
    </div>
  </div>
}

@if (canAccessEthan && isFloatingEthanVisible) {
  <div
    #chatButtonWrapper
    [ngClass]="{ 'chat-button-wrapper': true, hidden: !(ethanButtonVisible$ | async) }"
    [class.dragging]="isDragging"
    (mousedown)="onDragStart($event, chatButtonWrapper)"
  >
    <ng-container *ngIf="!chatIsOpen">
      <ts-button type="fab" color="primary" class="floating-chat chat-button" (buttonClick)="openCloseChat()">
        <img [ngClass]="'select-none pointer-events-none'" src="assets/icons/ethan-e.svg" alt="AI Ability" />
      </ts-button>
    </ng-container>
    <ng-container *ngIf="chatIsOpen">
      <ts-button type="fab" color="primary" class="floating-chat chat-button" (buttonClick)="openCloseChat()">
        <mat-icon>close</mat-icon>
      </ts-button>
    </ng-container>
  </div>
}
